import { render, staticRenderFns } from "./XRays_Pointer.vue?vue&type=template&id=27bd8cdc&"
import script from "./XRays_Pointer.vue?vue&type=script&lang=js&"
export * from "./XRays_Pointer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports